import { render, staticRenderFns } from "./InfoBookComponent.vue?vue&type=template&id=de5e984c&scoped=true&"
import script from "./InfoBookComponent.vue?vue&type=script&lang=js&"
export * from "./InfoBookComponent.vue?vue&type=script&lang=js&"
import style0 from "./InfoBookComponent.vue?vue&type=style&index=0&id=de5e984c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de5e984c",
  null
  
)

export default component.exports